import { ActiveUserToolTipProps } from '../../../types';

const ActiveUserToolTip: React.FC<ActiveUserToolTipProps> = ({ user, colorClass }) => {
  const getInitials = (name: string) => {
    return name
      .split(' ')
      .filter((part) => part.trim() !== '')
      .map((part) => part[0])
      .join('')
      .toUpperCase()
      .slice(0, 2);
  };

  return (
    <div key={user.id} className="relative group">
      <div className="relative">
        <div
          className={`w-10 h-10 rounded-full border-2 ${colorClass} border flex items-center justify-center text-white font-medium hover:z-10 transition-transform duration-200 ease-in-out transform group-hover:scale-110`}>
          {getInitials(user.name)}
        </div>
        <span className="bg-green-700 absolute top-0 left-0 w-3 h-3 rounded-full border-2 border-white" />
      </div>

      {/* Tooltip */}
      <div className="absolute bottom-full left-1/2 -translate-x-1/2 mb-2 px-2 py-1 bg-gray-900 text-white text-sm rounded-md opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-200 whitespace-nowrap">
        <div className="flex items-center space-x-1">
          <span>{user.name}</span>
        </div>
        {/* Arrow */}
        <div className="absolute bottom-0 left-1/2 -translate-x-1/2 translate-y-full w-0 h-0 border-l-[6px] border-l-transparent border-r-[6px] border-r-transparent border-t-[6px] border-t-gray-900" />
      </div>
    </div>
  );
};

export default ActiveUserToolTip;
